import { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useParams } from 'react-router-dom';
import { Button, Tabs, TabItem } from 'ypf-pas-general-ui-components';
import { BsChevronLeft } from 'react-icons/bs';

import TemplateRequest from '../../components/Templates/RequestTemplate/TemplateRequest';

import { ButtonsHeaderTemplate } from './TemplateWorkReport/ButtonsHeaderTemplate';
import TemplateWorkReport from './TemplateWorkReport/TemplateWorkReport';
import './ManageTemplate.scss';

const getTabTitle = (typeOfTemplate) =>
  typeOfTemplate === 'request' ? 'Solicitud de servicio' : 'Partes de trabajo';

const getContainerClass = (applyTemplateView) =>
  applyTemplateView ? 'container-apply-template' : 'container-manage-template';

// Con respecto a las props recibidas
// isRequestTemplateView se pasa porque en el modal de aplicar plantilla de solicitud de servicio
// no tenemos una forma de identificar que se refiere a este modal mediante url
const ManageTemplate = ({
  // Props que corresponden a los items del grid y los checkbox
  checkBoxState,
  itemCheck,
  setItemCheck,
  setCheckBoxState,
  // Props correspondientes a condicionales segun donde se consuma el componente
  applyTemplateView,
  isDraw,
  idDraw,
  isRequestTemplateView,
  viewWithOutCheckBox,
  idRequest,
  isSDS,
  setModalDeleteHide,
  monthly,
  contractNumber,
  previusPath,
  disabledButtonGenerateTamplate,
  withAmount,
  setWithAmount
}) => {
  const history = useHistory();
  const [newFetch, setNewFetch] = useState(false);
  const [isPublic, setIsPublic] = useState(false);
  const [templateNameToSearch, setTemplateNameToSearch] = useState('');
  const goForceReset = useRef(null);

  const { typeOfTemplate } = useParams();
  const tabTitle = getTabTitle(typeOfTemplate);
  const isRequestTemplate = typeOfTemplate === 'request';

  return (
    <div className={getContainerClass(applyTemplateView)}>
      {!applyTemplateView && (
        <div className="title">
          <Button
            colorIcon="primary"
            icon={BsChevronLeft}
            onClick={() => {
              history.push('/');
            }}
            type="button"
            variant="white"
            widthButton="42px"
          />
          <h2 className="pas-title">Modelos de Solicitudes</h2>
        </div>
      )}
      <div className="template-container">
        {!applyTemplateView ? (
          <Tabs className="mb-5" defaultActiveKey="workReport">
            <TabItem disabled eventKey="serviceRequest" title="" />
            <TabItem eventKey="workReport" title={tabTitle}>
              <ButtonsHeaderTemplate
                checkBoxState={checkBoxState}
                disabledButtonGenerateTamplate={disabledButtonGenerateTamplate}
                goForceReset={goForceReset}
                isPublic={isPublic}
                isRequestTemplate={isRequestTemplate}
                itemCheck={itemCheck}
                manageTemplateComponent
                previusPath={isRequestTemplate ? '/manage-temp/request' : '/manage-temp/workReport'}
                setIsPublic={setIsPublic}
                setNewFetch={setNewFetch}
                setTemplateNameToSearch={setTemplateNameToSearch}
                setWithAmount={setWithAmount}
                templateNameToSearch={templateNameToSearch}
                withAmount={withAmount}
              />
              {!isRequestTemplate && !isRequestTemplateView ? (
                <TemplateWorkReport
                  checkBoxState={checkBoxState}
                  contractNumber={contractNumber}
                  goForceReset={goForceReset}
                  isMonthly={null}
                  itemCheck={itemCheck}
                  newFetch={newFetch}
                  setCheckBoxState={setCheckBoxState}
                  setItemCheck={setItemCheck}
                  withAmount={withAmount}
                />
              ) : null}
              {isRequestTemplate ? (
                <TemplateRequest
                  checkBoxState={checkBoxState}
                  goForceReset={goForceReset}
                  isPublic={isPublic}
                  itemCheck={itemCheck}
                  newFetch={newFetch}
                  previusPath={previusPath}
                  setCheckBoxState={setCheckBoxState}
                  setItemCheck={setItemCheck}
                  templateNameToSearch={templateNameToSearch}
                />
              ) : null}
            </TabItem>
          </Tabs>
        ) : (
          <>
            {!viewWithOutCheckBox && (
              <ButtonsHeaderTemplate
                applyTemplateView={applyTemplateView}
                checkBoxState={checkBoxState}
                disabledButtonGenerateTamplate={disabledButtonGenerateTamplate}
                goForceReset={goForceReset}
                idDraw={idDraw}
                idRequest={idRequest}
                isDraw={isDraw}
                isPublic={isPublic}
                isRequestTemplate={isRequestTemplate || isRequestTemplateView}
                isSDS={isSDS}
                itemCheck={itemCheck}
                manageTemplateComponent
                monthly={monthly}
                previusPath={previusPath}
                setIsPublic={setIsPublic}
                setModalDeleteHide={setModalDeleteHide}
                setNewFetch={setNewFetch}
                setWithAmount={setWithAmount}
                withAmount={withAmount}
              />
            )}
            {!isRequestTemplate && !isRequestTemplateView ? (
              <TemplateWorkReport
                checkBoxState={checkBoxState}
                contractNumber={contractNumber}
                goForceReset={goForceReset}
                isMonthly={monthly}
                itemCheck={itemCheck}
                newFetch={newFetch}
                setCheckBoxState={setCheckBoxState}
                setItemCheck={setItemCheck}
                viewWithOutCheckBox={viewWithOutCheckBox}
                withAmount={withAmount}
              />
            ) : null}
            {isRequestTemplate || isRequestTemplateView ? (
              <TemplateRequest
                checkBoxState={checkBoxState}
                goForceReset={goForceReset}
                isPublic={isPublic}
                itemCheck={itemCheck}
                newFetch={newFetch}
                previusPath={previusPath}
                setCheckBoxState={setCheckBoxState}
                setItemCheck={setItemCheck}
                templateNameToSearch={templateNameToSearch}
                viewWithOutCheckBox={viewWithOutCheckBox}
              />
            ) : null}
          </>
        )}
      </div>
    </div>
  );
};

ManageTemplate.propTypes = {
  applyTemplateView: PropTypes.bool,
  checkBoxState: PropTypes.arrayOf(PropTypes.number),
  contractNumber: PropTypes.number,
  idDraw: PropTypes.string,
  idRequest: PropTypes.string.isRequired,
  isDraw: PropTypes.bool,
  isRequestTemplateView: PropTypes.bool,
  isSDS: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      contractNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      isSDS: PropTypes.bool,
      pathname: PropTypes.string
    })
  ]),
  itemCheck: PropTypes.arrayOf(PropTypes.shape({})),
  monthly: PropTypes.bool,
  previusPath: PropTypes.string,
  setCheckBoxState: PropTypes.func,
  setItemCheck: PropTypes.func,
  setModalDeleteHide: PropTypes.func,
  viewWithOutCheckBox: PropTypes.bool,
  disabledButtonGenerateTamplate: PropTypes.bool,
  setWithAmount: PropTypes.func,
  withAmount: PropTypes.bool
};

ManageTemplate.defaultProps = {
  applyTemplateView: false,
  checkBoxState: [],
  contractNumber: undefined,
  disabledButtonGenerateTamplate: false,
  idDraw: '',
  isDraw: false,
  isRequestTemplateView: false,
  isSDS: false,
  itemCheck: [],
  monthly: false,
  previusPath: '/',
  setCheckBoxState: () => {},
  setItemCheck: () => {},
  setModalDeleteHide: () => {},
  viewWithOutCheckBox: false,
  setWithAmount: () => {},
  withAmount: false
};
export default ManageTemplate;
